import { gql } from '@apollo/client';

export const GET_BEP_INPUTS = gql`
  query getBEPInputs($refetchData: Boolean) {
    getBEPInputs(refetchData: $refetchData) {
      partyId
      relnId
      accountNumber
      nationalId
      internetProducts {
        kind
        isSoftSuspended
        hasCaf
        productInstanceId
        productInstanceStatus
        productTypeId
      }
      coordinates {
        latitude
        longitude
      }
      address {
        addressLines
        municipality
        region
        postalCode
        countryCode
      }
      indoorUnit {
        deviceModel
      }
      serviceContractId
      isFiberPreconnected
      fiberCityId
      fiberAddressId
    }
  }
`;
